import React, { memo } from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { CsmAppSidebarSkeleton } from './CsmAppSidebarSkeleton.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebars-content-csm-app" */ './CsmAppSidebar.tsx'
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const AsyncCsmAppSidebarComponent = (): React.JSX.Element => (
	<UFOSegment name="csm-nav4-sidebar-app">
		<SidebarBoundary
			id="csm-nav4.sidebar.csm-app"
			packageName="jiraNavigationAppsSidebarNav4SidebarsContentCsmApp"
			ufoName="csm-nav4.sidebar.csm-app"
		>
			<Placeholder name="csm-nav4.sidebar.csm-app" fallback={<CsmAppSidebarSkeleton />}>
				<LazySidebarContent />
			</Placeholder>
		</SidebarBoundary>
	</UFOSegment>
);

const AsyncCsmAppSidebar: React.MemoExoticComponent<() => React.JSX.Element> = memo(
	AsyncCsmAppSidebarComponent,
);
export default AsyncCsmAppSidebar;
